import { make } from 'vuex-pathify';
import { FieldVisitTriggersService } from '../services/field-visit-trigger.service.js';

const service = new FieldVisitTriggersService();

const state = {
  fieldVisitTriggers: []
};

const mutations = make.mutations(state);

const actions = {
  async fetchFieldVisitTriggers({ commit }) {
    try {
      const { data } = await service.fetchFieldVisitTriggers();
      commit('SET_FIELD_VISIT_TRIGGERS', data);
      return data 
    } catch (error) {
      Logger.error('Getting Field Visit Triggers');
      throw error;
    }
  },

  async createFieldVisitTrigger(_, payload) {
    try {
      const { data } = await service.createFieldVisitTrigger(payload);
      return data
    }catch (error) {
      Logger.error('Creating Field Visit Trigger');
      throw error;
    }
  },

  async updateFieldVisitTrigger(_, { id, updates}) {
    try {
      const { data } = await service.updateFieldVisitTrigger(id, updates);
      return data;
    } catch (error) {
      Logger.error('Update Field Visit Trigger');
      throw error;
    }
  },

  async deleteFieldVisitTriggers(_, id) {
    try {
      const { data } = await service.deleteFieldVisitTrigger(id);
      return data
    } catch (error) {
      Logger.error('Delete Field Visit Trigger');
      throw error;
    }
  }
};

export default {
  state,
  mutations,
  actions
};